import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCryptoTrc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 40C9 40 0 31.0002 0 19.9004C0.1 8.90064 9 -0.0991726 20.1 0.00082534C31.1 0.100823 40 9.00064 40 20.2004C39.9 31.1002 31 40 20 40Z",
		fill: "#FC070C"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32.4118 14.01C31.4856 13.1107 30.5068 12.1604 29.6431 11.3937L29.5556 11.3325C29.41 11.2155 29.2458 11.1239 29.0699 11.0612L28.4033 10.9368C23.8033 10.0785 8.89296 7.29641 8.58625 7.33372C8.49553 7.34642 8.40882 7.37931 8.3325 7.42996L8.24937 7.49559C8.14702 7.59954 8.06928 7.72512 8.02187 7.86309L8 7.91996V8.27871C9.01229 11.0975 11.6419 17.3924 14.07 23.2048C16.1227 28.1188 18.0314 32.688 18.6968 34.5199C18.7844 34.7913 18.9509 35.3074 19.2612 35.3336H19.3312C19.4975 35.3336 20.2062 34.3974 20.2062 34.3974C20.2062 34.3974 32.8762 19.0324 34.158 17.3962C34.324 17.1946 34.4705 16.9778 34.5955 16.7487C34.6605 16.384 34.5293 16.012 34.2499 15.7687C33.7041 15.2647 33.0712 14.6502 32.4118 14.01ZM23.4568 17.5581L28.8643 13.0737L32.0362 15.9962L23.4568 17.5581ZM12.0469 9.63496L21.3568 17.2649L27.1099 12.4131L12.0469 9.63496ZM22.1968 19.2643L31.7256 17.7287L20.8318 30.8536L22.1968 19.2643ZM20.5781 18.7087L10.7825 10.3962L19.1606 30.8624L20.5781 18.7087Z",
		fill: "white"
	})]
});
export default SvgCryptoTrc;
